import { render, staticRenderFns } from "./TremfyaFooter.vue?vue&type=template&id=15ec7b22&scoped=true&"
import script from "./TremfyaFooter.vue?vue&type=script&lang=ts&"
export * from "./TremfyaFooter.vue?vue&type=script&lang=ts&"
import style0 from "./TremfyaFooter.vue?vue&type=style&index=0&id=15ec7b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ec7b22",
  null
  
)

export default component.exports